import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';

import { getCredentialEncryptionKeyRequest } from '../actions/GetCredentialEncryptionKeyRequestAction';
import { IGetSiteEncryptionKeyDataKey } from '../models/CredentialEncryptionModels';
import { RotateSiteEncryptionDataKeyRequest, RotateSiteEncryptionDataKeyResult } from '../serverApi/requests/RotateSiteEncryptionDataKeyRequest';
import { rotateSiteEncryptionKey } from '../services/CredentialEncryptionKeyService';


export interface KMSKeyGenerateViewOwnProps {
    closeDialog: CloseAndDismiss;
    dataKeyIds: IGetSiteEncryptionKeyDataKey[];
    coolDownPeriod: number;
}

export interface KMSKeyGenerateViewDispatchProps {
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyGenerateViewProps = KMSKeyGenerateViewOwnProps & KMSKeyGenerateViewDispatchProps;


export interface KMSKeyGenerateViewState {
    isRotating: boolean;
}

export class KMSKeyGenerateViewComponent extends React.PureComponent<KMSKeyGenerateViewProps, KMSKeyGenerateViewState> {

    constructor(props: KMSKeyGenerateViewProps) {
        super(props);
        this.state = {
            isRotating: false,
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyGenerateDialog_Ask()}</div>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyGenerateDialog_Description({MESSAGE: this.props.coolDownPeriod.toString()})}</div>
            {this.props.dataKeyIds?.length > 0 && (
                <>
                    <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyGenerateDialog_Warning()}</div>
                    <ul style={{paddingLeft: '20px'}}>
                        <li id="kms-key-generate-terms-1">{Messages.credentialEncryption_KMSKeyGenerateDialog_Warning_Bullet1()}</li>
                        <li id="kms-key-generate-terms-2">{Messages.credentialEncryption_KMSKeyGenerateDialog_Warning_Bullet2()}</li>
                    </ul>
                </>
            )}
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            showSpinner: this.state.isRotating,
                            children: Messages.credentialEncryption_KMSKeyGenerateDialog_Generate_button(),
                            onClick: () => this.handleGenerateKMSKey(),
                            testId: 'Generate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

  private handleGenerateKMSKey(): void {
    this.setState({isRotating: true}, () => {
        rotateSiteEncryptionKey(new RotateSiteEncryptionDataKeyRequest({}))
        .then((response: RotateSiteEncryptionDataKeyResult) => {
            if(response?.errors && response.errors.length > 0){
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyRotate_FailureToast() });
            } else if (this.props.dataKeyIds?.length > 0){
                ToasterService.instance.pop({ type: ToastType.Success, text: Messages.credentialEncryption_KMSKeyRotate_SuccessToast() });
                this.props.retrieveCredentialEncryptionKey();
            } else {
                ToasterService.instance.pop({ type: ToastType.Success, text: Messages.credentialEncryption_KMSKeyCreate_SuccessToast() });
                this.props.retrieveCredentialEncryptionKey();
            }
        }).catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyRotate_FailureToast() });
        }).finally(() => {
            this.setState({isRotating: false});
            this.props.closeDialog.close();
        });
        });
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyGenerateViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyGenerateView: React.ComponentClass<KMSKeyGenerateViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyGenerateViewComponent);